import { render, staticRenderFns } from "./HistoryDetailDialog.vue?vue&type=template&id=28f5f177"
import script from "./HistoryDetailDialog.vue?vue&type=script&lang=js"
export * from "./HistoryDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./HistoryDetailDialog.vue?vue&type=style&index=0&id=28f5f177&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports